import { LiveConfig } from 'smooth-doc/components';
import Button from "../../../../node_modules/smooth-doc/src/example/Button";
import * as React from 'react';
export default {
  LiveConfig,
  Button,
  React
};